import React, {useState, useEffect, useContext} from 'react'
import clsx from 'clsx'
import {makeStyles, useTheme} from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import {Toolbar, Tooltip, Grid} from '@material-ui/core/'
import List from '@material-ui/core/List'
import CssBaseline from '@material-ui/core/CssBaseline'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Navbar from '../Navbar/Navbar'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {MyAccountContext} from '../../containers/Layout'
import {
    GlobalSetting,
    HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG,
} from '../../../utils/constants'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

const drawerWidth = 260

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0 8px',
        zIndex: theme.zIndex.drawer + 5,
        width: '70px',
        height: '64px',
    },
    hamburgerClose: {
        alignItems: 'center',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    activePane: {
        backgroundColor: 'rgba(204, 224, 248, 1)',
        color: 'rgba(65, 148, 242, 1)',
    },
}))

const getNavigationArray = () => [
    {
        actions: 'View',
        fontIcon: 'home-alt',
        label: 'Home',
        class: null,
        id: 1,
        router: 'dashboard',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'hospital',
        label: 'Organization',
        class: null,
        id: 2,
        router: 'demographic',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'users-cog',
        label: 'User',
        class: null,
        id: 3,
        router: 'user',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'user-md',
        label: 'Clinician',
        class: null,
        id: 4,
        router: 'provider',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'map-marked-alt',
        label: 'Location',
        class: null,
        id: 5,
        router: 'location',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'cogs',
        label: 'Technical',
        class: null,
        id: 6,
        router: 'technical',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'box-check',
        label: 'Subscribed Programs',
        class: null,
        id: 7,
        router: 'enrolled',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
    {
        actions: 'View',
        fontIcon: 'box',
        label: 'Available Programs',
        class: null,
        id: 8,
        router: 'qualified',
        tooltip: null,
        isActive: false,
        isHidden: false,
    },
]

const NavigationDrawer = props => {
    const classes = useStyles()
    const theme = useTheme()
    const [open, setOpen] = useState(false)
    const {
        routeObject,
        setrouteObject,
        clientObject,
        setClientObject,
        clientProgramSelectedObject,
    } = useContext(MyAccountContext)

    const navArray = getNavigationArray()

    if (clientObject.entitytypeid === 3) {
        navArray.forEach((input, key) => {
            if (input.label === 'Location') {
                input.label = 'Emergency Department'
                input.router = 'ed'
                input.fontIcon = 'credit-card-front'
            }
            if (input.label === 'Technical') input.isHidden = true
        })
    }

    if (
        HIDE_TECHNICAL_SURVEY_MYACCOUNT_FOR_PRG.includes(
            clientProgramSelectedObject.toLowerCase()
        )
    ) {
        navArray.forEach(p => {
            if (p.label === 'Technical' || p.label === 'Available Programs')
                p.isHidden = true
        })
    }
    const [navigation, setNavigation] = useState([...navArray])

    useEffect(() => {
        let navArray1 = navigation
        for (let index = 0; index < navArray1.length; index++) {
            const element = navArray1[index]
            if (element.router.toLowerCase() === routeObject.key.toLowerCase())
                element.isActive = true
            else element.isActive = false
        }
        setNavigation([...navArray1])
    }, [routeObject])

    const handleDrawerOpen = () => setOpen(true)

    const handleDrawerClose = () => setOpen(false)

    // When user click outside except hamburger menu will close automatically.
    const handleClickAway = event => {
        if (
            document
                .getElementsByClassName('hamburger-container')[0]
                .contains(event.target)
        ) {
            return
        }
        setOpen(false)
    }

    const handleRouter = routeinfo => {
        setOpen(false)
        setrouteObject({...routeObject, key: routeinfo})
        //reset all program related objects to default
        setClientObject({
            ...clientObject,
            clientprogramid: 0,
            clientprogramname: '',
            programhost: '',
            programid: 0,
        })
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <div className="page-header_with-sidebar">
                <CssBaseline />
                <AppBar
                    position="fixed"
                    className={clsx('page-header', classes.appBar, {
                        [classes.appBarShift]: open,
                    })}
                >
                    <Toolbar className="page-header__toolbar">
                        <Grid className="fi-stack__item hamburger-container">
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                className={clsx(classes.menuButton, {
                                    [classes.hide]: open,
                                })}
                            >
                                <MenuIcon />
                            </IconButton>
                            <div className={classes.toolbar}>
                                <IconButton onClick={handleDrawerClose}>
                                    {theme.direction === 'rtl' ? (
                                        <ChevronRightIcon />
                                    ) : (
                                        <ChevronLeftIcon />
                                    )}
                                </IconButton>
                            </div>
                        </Grid>
                        <Navbar handleDrawerClose={handleDrawerClose} />
                    </Toolbar>
                </AppBar>
                <Drawer
                    variant="permanent"
                    className={clsx('fi-aside-left ', classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className="main-navigation__container">
                        <List className="main-navigation__ul">
                            {navigation.map(
                                (data, index) =>
                                    !data.isHidden && (
                                        <ListItem
                                            button
                                            key={data.router}
                                            onClick={() => handleRouter(data.router)}
                                            disabled={
                                                data.router === 'user'
                                                    ? GlobalSetting.EnableUserManagement
                                                        ? false
                                                        : true
                                                    : false
                                            }
                                            className={
                                                props.activeRoute === data.router
                                                    ? clsx(
                                                          'selected-main__nav',
                                                          classes.activePane
                                                      )
                                                    : ' '
                                            }
                                        >
                                            <ListItemIcon className="main-nav--icon__wrapper">
                                                <Tooltip
                                                    title={data.label}
                                                    placement="right"
                                                >
                                                    <span>
                                                        <FontAwesomeIcon
                                                            icon={['fal', data.fontIcon]}
                                                            className="tabgroup__iconimage"
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText primary={data.label} />
                                        </ListItem>
                                    )
                            )}
                        </List>
                    </div>
                </Drawer>
            </div>
        </ClickAwayListener>
    )
}

NavigationDrawer.defaultProps = {
    setRouter: () => {
        console.log('setRouter is called')
    },
}

export default NavigationDrawer
